import { ANNOUNCE } from "@/constants/testIds";

export default function AnnouncementBar() {
  return (
    <div
      data-testid={ANNOUNCE.bar}
      className="fixed top-0 inset-x-0 z-[60] h-9 bg-forest text-terracotta flex items-center justify-center px-4"
    >
      <p className="text-[11px] md:text-xs font-bold uppercase tracking-[0.22em] text-center leading-tight">
        Launching Winter 2026 - The Right Way to Deliver
      </p>
    </div>
  );
}
